import { formatDateForLanguage } from '@localization/formatters/dateFormatter';
import { DateFormat } from '@localization/formatters/dateFormatter';

/**
 * Formats a date for telemetry/analytics purposes.
 * Always uses 'en-US' locale to ensure consistent format for analytics review.
 *
 * @param input - Date input (Date, string, number, null, undefined)
 * @param format - Date format to use
 * @returns Formatted date string or undefined
 */
export const formatDateForTelemetry = (input: string | Date | number | null | undefined, format: DateFormat): string | undefined => {
  return formatDateForLanguage('en-US', input, format);
};

/**
 * Formats current date/time (now) for telemetry in ISO-like format: 'yyyy-MM-dd HH:mm'
 * Commonly used for datetime stamps in telemetry events.
 *
 * @returns Formatted date string in 'yyyy-MM-dd HH:mm' format (e.g., "2025-08-28 16:00")
 */
export const formatNowForTelemetry = (): string => {
  return formatDateForTelemetry(new Date(), 'yyyy-MM-dd HH:mm') ?? '';
};
